import axios from 'axios';

let serviceUrl = process.env.REACT_APP_BASE_API_ENDPOINT;
let nodeServiceUrl = process.env.REACT_APP_NODE_API_ENDPOINT;

export const getAuthToken = (attachBearerToToken) => {
  return !attachBearerToToken
    ? localStorage.getItem('msal.idtoken')
    : `Bearer ${localStorage.getItem('msal.idtoken')}`;
};

export const apiGetService = async (
  path = null,
  params,
  overriddenServiceURL = null,
) => {
  serviceUrl = overriddenServiceURL || process.env.REACT_APP_BASE_API_ENDPOINT;

  let serviceCall = axios({
    method: 'GET',
    url: `${serviceUrl}${path}`,
    headers: {
      Authorization: getAuthToken(true),
      Accept: 'application/json',
    },
    params: params,
  });

  return serviceCall
    .then((res) => {
      return res.data;
    })
    .catch((ex) => {
      return {
        status: 'fail',
        code: ex.response.status,
        error_message: ex.response.data.error_message,
      };
    });
};

export const apiPostService = async (options) => {
  let {
    path = '',
    payload = null,
    type = null,
    timeout = null,
    body,
    params = null,
    overriddenServiceURL = null,
    customHeaders = null,
    isFileUpload = false,
    attachBearerToToken = true,
    attachAuthKey = false,
  } = options;

  serviceUrl = overriddenServiceURL || process.env.REACT_APP_BASE_API_ENDPOINT;
  let token = getAuthToken(attachBearerToToken);
  let finalHeaders = customHeaders || {
    Authorization: token,
    'Content-Type': isFileUpload ? 'multipart/form-data' : 'application/json',
    Accept: 'application/json',
  };
  if (attachAuthKey) {
    finalHeaders = {
      ...finalHeaders,
      auth_token: token,
    };
  }

  let serviceCall = axios({
    method: 'POST',
    url: `${serviceUrl}${path}`,
    headers: finalHeaders,
    data: payload,
    responseType: type,
    timeout: timeout,
    body: body,
    params: params,
  });

  return serviceCall
    .then((res) => {
      return res.data;
    })
    .catch((ex) => {
      return {
        status: 'fail',
        code: ex.response.status,
        error_message: ex.response.data.error_message,
      };
    });
};

export const apiDeleteService = async (options) => {
  let {
    path,
    params = null,
    payload = null,
    overriddenServiceURL = null,
  } = options;

  serviceUrl = overriddenServiceURL || process.env.REACT_APP_BASE_API_ENDPOINT;

  return await axios({
    method: 'DELETE',
    url: `${serviceUrl}${path}`,
    headers: {
      Authorization: getAuthToken(true),
      'Content-Type': payload ? 'application/json' : '',
      Accept: 'application/json',
    },
    data: payload,
    params: params,
  });
};

export const apiPatchService = async (options) => {
  let {
    path = '',
    payload = null,
    type = null,
    timeout = null,
    body,
    params = null,
    overriddenServiceURL = null,
    customHeaders = null,
  } = options;

  serviceUrl = overriddenServiceURL || process.env.REACT_APP_BASE_API_ENDPOINT;

  let serviceCall = axios({
    method: 'PATCH',
    url: `${serviceUrl}${path}`,
    headers: customHeaders || {
      Authorization: getAuthToken(true),
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: payload,
    responseType: type,
    timeout: timeout,
    body: body,
    params: params,
  });

  return serviceCall
    .then((res) => {
      return res.data;
    })
    .catch((ex) => {
      return {
        status: 'fail',
        code: ex.response.status,
        error_message: ex.response.data.error_message,
      };
    });
};
